<template>
  <div class="animated fadeIn step-container">
    <div class="row">
      <div class="col-12">
        <h2>{{$t('message.feedback.title')}}</h2>
      </div>
      <div class="col-12">
        <div class="card">
          <div class="card-block">
            <div v-if="!$ismobile()">
              <table class="table table-bordered table-responsive">
                <thead width="100%">
                  <tr>
                    <th class="text-center" width="12%">{{$t('message.feedback.appointment_no')}}</th>
                    <th class="text-center" width="12%">{{$t('message.feedback.appointment_date')}}</th>
                    <th class="text-center" width="15%">{{$t('message.feedback.patient_name')}}</th>
                    <th class="text-center" width="15%">{{$t('message.feedback.doctor_name')}}</th>
                    <th class="text-center" width="12%">{{$t('message.feedback.score')}}</th>
                    <th class="text-center" width="34%">{{$t('message.feedback.comment')}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="review in reviews.data" :key="review.id">
                    <td class="text-center">
                      <a href="javascript:void(0)" @click.prevent="openAppointmentDetail(review.appointment.id)">{{review.appointment.id}}</a>
                    </td>
                    <td class="text-center">{{review.appointment.appointment_time | formatDateTimeFull}}</td>
                    <td>
                      <a v-if="review.appointment.ehr_patient_id" href="javascript:void(0)" @click.prevent="openPatient(review.appointment.ehr_patient_id)">{{`${review.appointment.firstname} ${review.appointment.lastname}`}}</a>
                      <div v-else>{{`${review.appointment.firstname} ${review.appointment.lastname}`}}</div>
                    </td>
                    <td>
                      <div>
                        <a href="javascript:void(0)" @click.prevent="openDoctor(review.appointment.doctor_id)">{{getDoctorName(review)}}</a>
                      </div>
                      <small class="text-one-ellipsis">{{getDoctorSpecialty(review)}}</small>
                    </td>
                    <td class="text-center">
                      <i v-for="n in ratingKeys" :key="n" class="text-danger fa" :class="{'fa-heart': n < review.rating, 'fa-heart-o': n >= review.rating}" aria-hidden="true"></i>
                    </td>
                    <td class="text-justify">
                      <span>{{viewContent(review.content, !review.showMoreContent)}}</span>
                      <a v-if="review.moreContentEnable" class="view-more-btn" href="javascript:void(0)" @click.prevent="toggleMoreContent(review)">{{review.showMoreContent ? $t('action_message.close') : $t('action_message.view_more')}}</a>
                    </td>
                  </tr>
                  <tr v-if="loaded && reviews.data.length === 0">
                    <td colspan='6' style='text-align: center;' class='alert alert-warning'>
                      <span>{{$t('message.feedback.no_comment')}}</span>
                    </td>
                  </tr>
                  <tr v-if="loading">
                    <td colspan='6' style='text-align: center;' class='alert alert-warning'><div v-show='loading' class='btn btn-sm'><sync-loader size='10px'></sync-loader></div></td>
                  </tr>
                </tbody>
              </table>
              <div class='pagination'>
                <div><strong>{{$t('message.pagination.show')}}</strong> {{ reviews.from }} - {{ reviews.to }} <strong>{{$t('message.pagination.from')}}</strong> {{ reviews.total }} <strong>{{$t('message.pagination.rows')}}</strong></div>
                <a class='btn' @click="reviews.prev_page_url && loadReviews(reviews.prev_page_url)" :class="{ enable: reviews.prev_page_url }">{{$t('message.pagination.prev')}}</a>
                <a class='btn' @click="reviews.next_page_url && loadReviews(reviews.next_page_url)" :class="{ enable: reviews.next_page_url }">{{$t('message.pagination.next')}}</a>
              </div>
            </div>

            <!-- For mobile -->
            <div v-else>
              <div class="feedback-container">
                <div v-if="loaded && reviews.data.length !== 0" class='pagination'>
                  <div><strong>{{$t('message.pagination.show')}}</strong> {{ reviews.from }} - {{ reviews.to }} <strong>{{$t('message.pagination.from')}}</strong> {{ reviews.total }} <strong>{{$t('message.pagination.rows')}}</strong></div>
                  <a class='btn' @click="reviews.prev_page_url && loadReviews(reviews.prev_page_url)" :class="{ enable: reviews.prev_page_url }">{{$t('message.pagination.prev')}}</a>
                  <a class='btn' @click="reviews.next_page_url && loadReviews(reviews.next_page_url)" :class="{ enable: reviews.next_page_url }">{{$t('message.pagination.next')}}</a>
                </div>
                <div class='card feedback-content' v-for="review in reviews.data" :key="review.id">
                  <div class='card-header'>
                    <div class="row">
                      <span class='col-6 app-id'>{{$t('message.feedback.appointment_no')}}:
                        <strong>
                          <a href="javascript:void(0)" @click.prevent="openAppointmentDetail(review.appointment.id)">{{review.appointment.id}}</a>
                        </strong>
                      </span>
                      <span class='col-6 app-date text-right'>{{review.appointment.appointment_time | formatDateTimeFull}}</span>
                    </div>
                  </div>
                  <div class='card-block'>
                    <h6 class='app-username'>
                      <a href="javascript:void(0)" @click.prevent="openPatient(review.appointment.ehr_patient_id)">{{`${review.appointment.firstname} ${review.appointment.lastname}`}}</a>
                    </h6>
                    <h5 class='app-doctor'>
                      <a href="javascript:void(0)" @click.prevent="openDoctor(review.appointment.doctor_id)">{{getDoctorName(review)}}</a>
                    </h5>
                    <div class='app-rate'>
                      <i v-for="n in ratingKeys" :key="n" class="text-danger fa" :class="{'fa-heart': n < review.rating, 'fa-heart-o': n >= review.rating}" aria-hidden="true"></i>
                    </div>
                    <span class="app-comment">{{viewContent(review.content, !review.showMoreContent)}}</span>
                    <a v-if="review.moreContentEnable" class="view-more-btn" href="javascript:void(0)" @click.prevent="toggleMoreContent(review)">{{review.showMoreContent ? $t('action_message.close') : $t('action_message.view_more')}}</a>
                  </div>
                </div>
              </div>
              <h6 v-if="loaded && reviews.data.length === 0" class="text-center alert alert-warning">
                {{$t('message.feedback.no_comment')}}
              </h6>
              <div v-if="loading" class="text-center">
                <div v-show='loading' class='btn btn-sm'><sync-loader size='10px'></sync-loader></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SyncLoader from 'vue-spinner/src/SyncLoader'

export default {
  components: {
    SyncLoader
  },
  data () {
    return {
      limitContentLength: 80,
      reviews: {},
      loading: false,
      loaded: false,
      ratingKeys: [...Array(5).keys()]
    }
  },
  methods: {
    openAppointmentDetail (id) {
      if (id) this.$router.push({path: `/appointments/${id}`})
    },
    openPatient (id) {
      if (id) this.$router.push({path: `/patient/${id}`})
    },
    openDoctor (id) {
      if (id) this.$router.push({path: `/doctor/step1/${id}`, query: {action: 'edit'}})
    },
    getDoctorName (review) {
      if (review && review.doctor) {
        return `${review.doctor.firstname} ${review.doctor.lastname}`
      }
      return ''
    },
    getDoctorSpecialty (review) {
      return ''
    },
    toggleMoreContent (review) {
      review.showMoreContent = !review.showMoreContent
    },
    viewContent (content, isTruncate) {
      if (isTruncate) {
        return this.$options.filters.truncate(content, this.limitContentLength)
      }
      return content
    },
    async loadReviews (url) {
      this.loading = true
      this.loaded = false
      var params = {}
      if (this.$guser.isClinic() || this.$guser.isClinicMulti()) {
        params.clinic_id = this.$guser.user.clinic.id
      } else if (this.$guser.isDoctor()) {
        params.doctor_id = this.$guser.user.doctor.id
      }
      let reviewResp = await this.$http.get(url || this.$APP_CONFIG.api.admin.reviews(this.$route, this.$guser),
        {
          params: params,
          credentials: true
        })

      this.loading = false
      this.loaded = true
      this.reviews = Object.assign({}, {
        from: reviewResp.body.from,
        to: reviewResp.body.to,
        total: reviewResp.body.total,
        per_page: reviewResp.body.per_page,
        current_page: reviewResp.body.per_page,
        next_page_url: reviewResp.body.next_page_url,
        prev_page_url: reviewResp.body.prev_page_url,
        data: reviewResp.body.data.map(rv => {
          return Object.assign({}, rv, {
            showMoreContent: false,
            moreContentEnable: (rv.content) && (rv.content.length > this.limitContentLength)
          })
        })
      })
    }
  },
  created () {
    this.loadReviews()
  }
}
</script>

<style lang="scss">
@import "../../assets/base_container";

.view-more-btn {
  float: right;
}

.text-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-height: 16px;
  max-height: 32px;
  /* fallback */
  -webkit-line-clamp: 2;
  /* number of lines to show */
  -webkit-box-orient: vertical;
}
.text-one-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-height: 16px;
  max-height: 16px;
  /* fallback */
  -webkit-line-clamp: 1;
  /* number of lines to show */
  -webkit-box-orient: vertical;
}

.pagination {
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// Feedback.vue?32d380a2